import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, filter, finalize, of, retry, switchMap, take, tap } from 'rxjs';
import { Constant } from '../../../constants/constant';
import { Router } from '@angular/router';
import { CartService } from '../cart.service';
import { CommonService } from '../common.service';
import { CookieService } from '../cookie.service';
import { LoaderService } from '../loader.service';
import { UserService } from '../user.service';


@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  userLoggedIn: boolean | undefined;
  isRequested401 = false;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  isRefreshingToken = false;
  public onlineFlag = navigator.onLine;

  constructor(
    private basicAuthenticationService: UserService,
    private router: Router,
    private loaderService: LoaderService,
    private commonService: CommonService,
    private cookieService: CookieService,
    private cartServices: CartService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let clonedRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer YOUR_AUTH_TOKEN`,
      },
    });

    console.log('Outgoing request:', clonedRequest);

    // URL handling for loader (from second interceptor)
    let url = this.router.url;

    if (url.includes("/checkout-appointments?sid=")) {
      this.loaderService.hide();
    } else if (clonedRequest.url.includes("api/order")) {
      this.loaderService.show();
    } else if (clonedRequest.url.includes("api/ig/order")) {
      this.loaderService.show();
    } else if (url == '/home') {
      this.loaderService.hide();
    } else if (url == '/category') {
      this.loaderService.hide();
    } else if (clonedRequest.url.includes("api/core/download")) {
      this.loaderService.hide();
    } else if (url == '/course-detail') {
      this.loaderService.hide();
    } else if (clonedRequest.url.includes("api/cart")) {
      this.loaderService.show();
    } else if (clonedRequest.url.includes("api/ig/cart")) {
      this.loaderService.show();
    } else if (clonedRequest.url.includes("api/core/download?fileName")) {
      this.loaderService.hide();
    } else if (clonedRequest.url.includes("api/auth/changePassword")) {
      this.loaderService.show();
    } else if (clonedRequest.url.includes("api/catalog/search")) {
      this.loaderService.hide();
    } else if (clonedRequest.url.includes("api/auth/user/login")) {
      this.loaderService.show();
    } else if (clonedRequest.url.includes("api/auth/forgetpassword")) {
      this.loaderService.show();
    } else if (clonedRequest.url.includes("api/auth/password/verifyToken")) {
      this.loaderService.show();
    } else if (this.router.url.includes("/pr?sid=")) {
      this.loaderService.hide();
    } else if (clonedRequest.url.includes("api/catalog/home")) {
      this.loaderService.hide();
    } else if (this.router.url == "/home") {
      this.loaderService.hide();
    } else if (this.router.url == "/") {
      this.loaderService.hide();
    } else if (
      clonedRequest.url ==
        "https://devapp.calsoftgroup.com/ecom-svc-catalog-1.0-SNAPSHOT/api/catalog/search?page=0&size=10&sort=price,DESC" ||
      this.router.url == "/orders" ||
      clonedRequest.url.includes("home") == true
    ) {
      this.loaderService.hide();
    } else if (
      clonedRequest.url.includes("api/config/pincode/filter?search=")
    ) {
      this.loaderService.hide();
    } else if (
      clonedRequest.url.includes("api/ig/config/pincode/filter?search=")
    ) {
      this.loaderService.hide();
    } else if (
      clonedRequest.url.includes("api/config/pincode/all/site?page=")
    ) {
      this.loaderService.hide();
    } else if (
      clonedRequest.url.includes("api/ig/config/pincode/all/site?page=")
    ) {
      this.loaderService.hide();
    } else if (
      clonedRequest.url.includes("api/catalog/cms/page?")
    ) {
      this.loaderService.hide();
    } else if (
      clonedRequest.url.includes("api/catalog/categories/idx/nestedPostion")
    ) {
      this.loaderService.hide();
    } else {
      this.loaderService.show();
    }

    // Authentication handling (from second interceptor)
    let basicAuthHeaderString = this.basicAuthenticationService.getStorageToken(
      Constant.X_XSRF_TOKEN
    );

    if (
      basicAuthHeaderString != "" &&
      Constant.DEVICE_TYPE == "MOBILE"
    ) {
      clonedRequest = this.addToken(clonedRequest);
    } else if (Constant.DEVICE_TYPE == "MOBILE") {
      clonedRequest = clonedRequest.clone({
        withCredentials: true,
        setHeaders: {
          [Constant.DEVICE]: Constant.DEVICE_TYPE,
          [Constant.ENTERPRISE_SITE]: Constant.REFERER,
        },
      });
    } else if (basicAuthHeaderString != "") {
      this.userLoggedIn = true;
      clonedRequest = clonedRequest.clone({
        withCredentials: true,
        setHeaders: {
          [Constant.X_XSRF_TOKEN]: basicAuthHeaderString,
        },
      });
    } else {
      this.userLoggedIn = false;
      clonedRequest = clonedRequest.clone({
        withCredentials: true,
      });
    }

    return next.handle(clonedRequest).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.loaderService.hide();
          }
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            this.loaderService.hide();
            if (err.status === 410) {
              return this.handle401Error(clonedRequest, next);
            } else if (err.status === 401) {
              this.loaderService.hide();
              sessionStorage.clear();
              if (basicAuthHeaderString != "") {
                if (Constant.DEVICE_TYPE == "MOBILE") {
                  let lat = localStorage.getItem('latitude');
                  let long: any = localStorage.getItem('longitude');
                  let title: any = localStorage.getItem('itle');
                  localStorage.clear();
                  localStorage.removeItem(Constant.CART_COUNT)
                  this.cartServices.responseCache1 = new Map();
                  if (lat != null) {
                    localStorage.setItem('latitude', lat);
                    localStorage.setItem('longitude', long);
                    localStorage.setItem('title', title);
                    this.router.navigate(["/"]);
                  }
                } else {
                  if (!this.isRequested401) {
                    this.isRequested401 = true;
                    this.cookieService.deleteAll();
                    localStorage.removeItem(Constant.CART_COUNT)
                    this.cartServices.responseCache1 = new Map();
                    this.basicAuthenticationService.logout().subscribe((response: any) => {
                      this.isRequested401 = false;
                      this.isRefreshingToken = true;
                      this.router.navigate(["/"]);
                    });
                    sessionStorage.clear();
                  }
                }
              } else {
                this.router.navigate(["/"]);
              }
            }
            if (err.status === 500 || err.status === 0) {
              this.loaderService.hide();
              this.router.navigate(["/error/500"]);
            } else if (!navigator.onLine) {
              this.loaderService.hide();
              this.router.navigate(["error/nointernet"]);
            }
          }
          return null;
        }
      ),
      finalize(() => {
        console.log('Request completed'); // From first interceptor
      })
    );
  }

  addToken(request: HttpRequest<any>) {
    let basicAuthHeaderString = this.basicAuthenticationService.getStorageToken(
      Constant.X_XSRF_TOKEN
    );
    if (basicAuthHeaderString != "") {
      return request.clone({
        headers: new HttpHeaders({
          [Constant.X_XSRF_TOKEN]:
            this.basicAuthenticationService.getStorageToken(
              Constant.X_XSRF_TOKEN
            ),
          [Constant.XSRF_TOKEN]:
            this.basicAuthenticationService.getStorageToken(
              Constant.XSRF_TOKEN
            ),
          [Constant.DEVICE]: Constant.DEVICE_TYPE,
          [Constant.ENTERPRISE_SITE]: Constant.REFERER,
        }),
      });
    } else {
      return request;
    }
  }

  private handle401Error(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<any> {
    if (!this.isRefreshingToken) {
      this.tokenSubject.next('');
      this.isRefreshingToken = true;
      this.basicAuthenticationService.currentAccessToken = null;

      this.basicAuthenticationService.getNewAccessToken().subscribe(
        (response: any) => {
          if (response["status_code"] == Constant.RESPONSE_SUCCESS) {
            const i = response["data"];
            this.basicAuthenticationService.storeAccessToken(i);
            this.tokenSubject.next(i);

            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.onSameUrlNavigation = "reload";

            if (this.router.url.includes("/pr?sid=")) {
              let value = this.router.url.split("/pr?sid=");
              this.commonService.goToCategoryWithEncryptedKey(
                value[0].slice(0),
                value[1]
              );
            } else if (this.router.url.includes("?sid=")) {
              let value = this.router.url.split("?sid=");
              this.commonService.productSearch(value[0].slice(8));
            } else {
              this.router.navigate([this.router.url]);
            }
            this.isRefreshingToken = false;
            return next.handle(this.addToken(request)).pipe(retry(1));
          } else {
            this.isRefreshingToken = false;
            let lat = localStorage.getItem('atitude');
            let long: any = localStorage.getItem('ongitude');
            let title: any = localStorage.getItem('itle');
            localStorage.clear();
            this.router.navigate(["/"]);
            if (lat != null) {
              localStorage.setItem('latitude', lat);
              localStorage.setItem('longitude', long);
              localStorage.setItem('title', title);
            }
          }
          return null;
        },
        (err) => {
          this.isRefreshingToken = false;
          let lat = localStorage.getItem('atitude');
          let long: any = localStorage.getItem('ongitude');
          let title: any = localStorage.getItem('itle');
          localStorage.clear();
          this.router.navigate(["/"]);
          if (lat != null) {
            localStorage.setItem('latitude', lat);
            localStorage.setItem('longitude', long);
            localStorage.setItem('title', title);
          }
        }
      );
    } else {
      return this.tokenSubject.pipe(
        filter((token) => token !== null),
        take(1),
        switchMap((token) => {
          return next.handle(this.addToken(request));
        })
      );
    }
    return of(null);
  }
}